import { FormattedMessage } from 'react-intl'
import React from 'react'
import classNames from 'classnames'
import logo1x from '../../images/logo.png'
import logo2x from '../../images/logo@2x.png'
import { translationsShared } from '../translations/translationsShared'

const LogoLeft: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={classNames('flex flex-col items-start', className)}>
      <div className="flex items-center">
        <img
          srcSet={`${logo1x} 1x, ${logo2x} 2x`}
          alt="ZagZag"
          className="size-12 rounded-full bg-black p-2"
        />
        <h1 className="ml-4 text-2xl font-bold">
          <FormattedMessage {...translationsShared.logoName} />
        </h1>
      </div>
      <h2 className="mb-2 mt-4 text-md">
        <FormattedMessage {...translationsShared.logoTitle} />
      </h2>
      <h3 className="text-sm">
        <FormattedMessage {...translationsShared.logoSubtitle} />
      </h3>
    </div>
  )
}

export { LogoLeft }
